// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"21404ede","890":"9b2c2113","951":"c3a7d1ca"}[chunkId] + ".chunk.css";
};